import { render, staticRenderFns } from "./Constitution.vue?vue&type=template&id=4e1691b4&"
import script from "./Constitution.vue?vue&type=script&lang=js&"
export * from "./Constitution.vue?vue&type=script&lang=js&"
import style0 from "./Constitution.vue?vue&type=style&index=0&id=4e1691b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports